import ProfilePlaytime from './components/ProfilePlaytime';
import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';

/**
 * Garrison Pro, on the forum.
 *
 * 🚨 Everything here is PUSHED to garrison, never called into it.
 *
 * The two bundles are separate files and nothing orders them — pro's may
 * evaluate before garrison's has run a line. So this pushes onto an array it
 * creates if absent, and whichever side runs second drains it. Exactly the
 * pattern garrison's own widget hosts use for the same reason.
 *
 * 🚨 The panels do NOT re-check entitlement. They are in this bundle, and this
 * bundle only exists on a forum that has the paid package — that IS the check.
 * A second one here would be a licence check in a place a licence check cannot
 * work, and it would eventually disagree with the server, which decides the
 * real answer in garrison's Dispatcher.
 */
function queue(panel) {
  globalThis.GarrisonPanelQueue = globalThis.GarrisonPanelQueue || [];
  globalThis.GarrisonPanelQueue.push(panel);
}

/*
 * The panels only ever render on a server page, so they load from their own
 * chunk the first time one asks (see garrison-pro-panels.js). Until it arrives a panel
 * renders nothing, which garrison's page already handles — it filters nulls —
 * and the redraw once it lands draws them all.
 */
let loaded = null;
let loading = null;
function panel(name) {
  return server => {
    if (loaded) return m(loaded[name], {
      server
    });
    loading ||= import(/* webpackChunkName: 'forum/garrison-pro-panels', webpackMode: 'lazy-once' */ './garrison-pro-panels').then(mod => {
      loaded = mod;
      m.redraw();
    });
    return null;
  };
}
app.initializers.add('ernestdefoe-garrison-pro', () => {
  /*
   * 🚨 The order below is the order somebody WORKS in, and it is the same
   * argument garrison's own page makes about its console and its facts.
   *
   * The leaderboard and the identity form come first because they are the only
   * things here an ordinary member can use. Then the console's neighbours.
   * Backups sit BELOW the console — arriving after an alert the questions are
   * "what is it doing", "what does the log say", and only then "do I need to
   * put yesterday's world back", and a Restore button above the evidence
   * invites somebody to use it before they have read anything. Settings sit
   * last, by which point an operator has seen the state, read the console and
   * been shown that a backup exists.
   */
  queue({
    key: 'board',
    priority: 10,
    view: panel('Leaderboard')
  });
  queue({
    key: 'link',
    priority: 20,
    view: panel('LinkIdentity')
  });

  /*
   * 🚨 Rendered when the API SENT a backup list, not when a flag says it
   * should be. garrison's ListServersController omits the field entirely for
   * anybody below staff, so its presence IS the permission answer, already
   * made server-side. A second client-side rule here would be a second place
   * for the two to disagree — and the one that loses is always the one that
   * hides things.
   */
  queue({
    key: 'backups',
    priority: 30,
    view: s => s.backups !== undefined ? panel('Backups')(s) : null
  });
  queue({
    key: 'settings',
    priority: 40,
    view: s => s.canConfig ? panel('Settings')(s) : null
  });

  /*
   * 🚨 On the profile, because that is where somebody looks somebody else up.
   *
   * The link between a forum account and an in-game character is the whole
   * reason this product lives in a forum rather than beside one, and a profile
   * is where a community actually asks "who is this?". Rendering nothing at
   * all for the many members with no linked character keeps it out of the way
   * of everybody it does not concern.
   */
  extend('flarum/forum/components/UserCard', 'infoItems', function (items) {
    const user = this.attrs.user;
    if (!user) return;
    items.add('garrison', m(ProfilePlaytime, {
      user: user
    }), -10);
  });
});flarum.reg.addChunkModule('ernestdefoe-garrison-pro:forum/garrison-pro-panels', '47', 'ernestdefoe-garrison-pro', 'forum/garrison-pro-panels');
flarum.reg.addChunkModule('ernestdefoe-garrison-pro:forum/garrison-pro-panels', '47', 'ernestdefoe-garrison-pro', 'forum/components/Backups');
flarum.reg.addChunkModule('ernestdefoe-garrison-pro:forum/garrison-pro-panels', '47', 'ernestdefoe-garrison-pro', 'forum/components/Leaderboard');
flarum.reg.addChunkModule('ernestdefoe-garrison-pro:forum/garrison-pro-panels', '47', 'ernestdefoe-garrison-pro', 'forum/components/LinkIdentity');
flarum.reg.addChunkModule('ernestdefoe-garrison-pro:forum/garrison-pro-panels', '47', 'ernestdefoe-garrison-pro', 'forum/components/Settings');